import { render, staticRenderFns } from "./OrdersProductsInformation.vue?vue&type=template&id=58a5dc8d&"
import script from "./OrdersProductsInformation.vue?vue&type=script&lang=js&"
export * from "./OrdersProductsInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports